<img
  class="header-public-logo d-block mx-auto"
  [src]="logoUrl || './assets/images/brand/logo.svg'"
  alt="Logo"
/>